import React, { createContext, useContext, useState } from "react"

type DirtyFormsState = Record<string, boolean>

const DirtyFormsContext = createContext<{
  dirtyForms: DirtyFormsState
  hasUnsavedChanges: boolean
  setFormDirty: (formId: string, isDirty: boolean) => void
}>({
  dirtyForms: {},
  hasUnsavedChanges: false,
  setFormDirty: () => {},
})

export const useDirtyForms = () => useContext(DirtyFormsContext)

export const DirtyFormsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dirtyForms, setDirtyForms] = useState<DirtyFormsState>({})

  const setFormDirty = (formId: string, isDirty: boolean) => {
    setDirtyForms((prev) => ({ ...prev, [formId]: isDirty }))
  }

  const hasUnsavedChanges = Object.values(dirtyForms).some(Boolean)

  return (
    <DirtyFormsContext.Provider value={{ dirtyForms, hasUnsavedChanges, setFormDirty }}>
      {children}
    </DirtyFormsContext.Provider>
  )
}
